import React from 'react'

const PrivacyAndPolicy = () => {
    return (
        <div>
            <h2 className="font-bold text-xl mb-4">Privacy Policy</h2>
            <p>
                Your privacy is important to us. This Privacy Policy explains how we collect, use, and safeguard your personal information when you use our services.
            </p>
            <p>
                We may collect personal details such as your name, email, phone number, address, and payment information for order processing and customer support. We also collect non-personal data like browsing activity, device details, and IP addresses to improve our website and services.
            </p>
            <p>
                Your information is used solely for fulfilling orders, providing customer service, processing payments, and sending promotional updates (if you opt-in). We do not sell, rent, or share your personal data with third parties, except as required by law or to trusted partners assisting us in operations.
            </p>
            <p>
                We use encryption, firewalls, and secure payment gateways to protect your data. However, no method of transmission is 100% secure, and we cannot guarantee absolute security.
            </p>
            <p>
                By using our website, you consent to this Privacy Policy. Updates to this policy will be posted on this page with revised dates. Please check periodically for changes.
            </p>
        </div>

    )
}

export default PrivacyAndPolicy